import React from 'react';
import { Link } from 'react-router-dom';
import ROUTES from '../../common/Routing/Routes';
import katyaValeraPhoto from '../../../images/about/katya-valera.jpg';
import aboutMePhoto from '../../../images/about/about-me.jpg';
import InstagramEmbed from '../../common/InstagramEmbed/InstagramEmbed';
import './AboutPage.css';

const SOCIAL_DRONE_URL = 'https://www.socialdrone.com.ua/';
export const DONATION_JAR_URL = 'https://send.monobank.ua/jar/4EJnLMD5N1';
const READERLY_INSTAGRAM_URL = 'https://www.instagram.com/readerly_com/';
const FOUNDER_INSTAGRAM_URL = 'https://www.instagram.com/caktus_k/';
const FEATURED_INSTAGRAM_POST_URLS = [
  'https://www.instagram.com/p/DdhJaHdDHor/',
  'https://www.instagram.com/p/DeJoj-miKcO/',
];

function AboutPage() {
  return (
    <div className="about default-container">
      <section className="about-panel">
        <h1>Про Readerly</h1>
        <p>
          Readerly — це волонтерський проєкт для людей, які люблять книжки, але не завжди хочуть
          купувати кожне видання назавжди. Книжки тут можна взяти в оренду за донат, додати у
          вішліст, стати в чергу на зайняті й оформити доставку (Укрпошта/Нова пошта) або доставку
          по Івано-Франківську.
        </p>
        <p>
          У кожного примірника є свій формуляр — видно, скільки читачів уже тримали його в руках
          і що вони про нього думають. Як усе влаштовано з оплатою, доставкою і поверненням —{' '}
          <Link to={ROUTES.FAQ}>у відповідях на часті питання</Link>.
        </p>
      </section>

      <section className="about-panel about-team">
        <h2>Хто стоїть за проєктом</h2>
        <div className="about-team-grid">
          <figure className="about-team-photo">
            <img src={katyaValeraPhoto} alt="Катя і Валера" loading="lazy" />
            <figcaption>Це Катя і Валера</figcaption>
          </figure>
          <figure className="about-team-photo">
            <img src={aboutMePhoto} alt="Засновниця Readerly" loading="lazy" />
            <figcaption>А це я — тримаю в руках парочку книг з каталогу</figcaption>
          </figure>
        </div>
        <p>
          Вони в рамках проєкту{' '}
          <a href={SOCIAL_DRONE_URL} target="_blank" rel="noopener noreferrer">
            Social Drone
          </a>{' '}
          збирають дрони своїми руками для ЗСУ.
        </p>
        <p>
          Усі гроші з оренди йдуть на деталі для FPV-дронів. Донати надходять на банку Readerly —{' '}
          <a href={DONATION_JAR_URL} target="_blank" rel="noopener noreferrer">
            send.monobank.ua/jar/4EJnLMD5N1
          </a>
          , а наприкінці кожного місяця ми переказуємо всю суму Каті й Валері.
        </p>
      </section>

      <section className="about-panel">
        <h2>Ми в Instagram</h2>
        <p>
          Новинки каталогу, підбірки і новини проєкту:{' '}
          <a href={READERLY_INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
            @readerly_com
          </a>
          .
        </p>
        <p>
          А це мій особистий інстаграм:{' '}
          <a href={FOUNDER_INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
            @caktus_k
          </a>
          .
        </p>
        <div className="about-instagram-posts">
          {FEATURED_INSTAGRAM_POST_URLS.map((url) => (
            <InstagramEmbed key={url} url={url} />
          ))}
        </div>
      </section>

      <section className="about-panel">
        <h2>Як працює доставка</h2>
        <p>
          Ви оплачуєте книжку і доставку до себе. Коли читання закінчилось — надсилаєте книжку
          назад, а доставку у зворотному напрямку оплачуємо вже ми.
        </p>
        <p>
          Щоб зворотна доставка коштувала менше, будь ласка, зберігайте пакування, у якому
          прийшла книжка, і використайте його ж для повернення.
        </p>
      </section>
    </div>
  );
}

export default AboutPage;
